/* Brillo — product page: variant selection, gallery, lightbox, quantity. */
(function () {
  'use strict';
  var B = window.Brillo || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = B.reduceMotion;

  function initProduct(root) {
    if (root.__product) return; root.__product = true;
    var sectionId = root.getAttribute('data-section-id');
    var handle = root.getAttribute('data-product-handle');
    var baseUrl = root.getAttribute('data-product-url');
    if (B.recordRecent) B.recordRecent(handle);

    /* ---------- Gallery ---------- */
    var gallery = $('[data-gallery]', root);
    var slides = gallery ? $$('[data-gallery-slide]', gallery) : [];
    var thumbs = gallery ? $$('[data-gallery-thumb]', gallery) : [];
    var counter = gallery && $('[data-gallery-counter]', gallery);
    var gi = Math.max(0, (parseInt(gallery && gallery.getAttribute('data-start'), 10) || 1) - 1);

    function show(i, focusThumb) {
      if (!slides.length) return;
      gi = (i + slides.length) % slides.length;
      slides.forEach(function (sl, k) {
        var on = k === gi;
        sl.classList.toggle('is-active', on);
        if (!on && B.pauseMediaIn) B.pauseMediaIn(sl);
        if (!on) $$('iframe[data-player]', sl).forEach(function (f) { f.remove(); var b = $('[data-external-play]', sl); if (b) b.hidden = false; });
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === gi ? 'true' : 'false'); });
      if (counter) counter.textContent = (gi + 1) + ' / ' + slides.length;
      if (focusThumb && thumbs[gi]) thumbs[gi].focus();
      if (lbOpen()) renderLightbox();
    }
    function showMediaId(id) {
      if (!id) return;
      var k = -1; slides.forEach(function (s, i) { if (s.getAttribute('data-media-id') === String(id)) k = i; });
      if (k > -1) {
        show(k);
        var stacked = gallery && $('.gallery__stacked-item[data-media-id="' + id + '"]', gallery);
        if (stacked && window.matchMedia('(min-width: 960px)').matches && gallery.classList.contains('gallery--stacked')) stacked.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
    }
    if (gallery) {
      var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { show(gi - 1); });
      if (next) next.addEventListener('click', function () { show(gi + 1); });
      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function () { show(k); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); show(gi + 1, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(gi - 1, true); }
        });
      });
      var stage = $('[data-gallery-stage]', gallery), tx = 0, ty = 0;
      if (stage) {
        stage.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? gi + 1 : gi - 1);
        }, { passive: true });
      }
    }

    /* ---------- Lightbox ---------- */
    var lbName = 'lightbox-' + sectionId;
    var lb = $('[data-drawer="' + lbName + '"]');
    var lbItem = lb && $('[data-lightbox-item]', lb);
    var lbCounter = lb && $('[data-lightbox-counter]', lb);
    var zoomBtn = lb && $('[data-lightbox-zoom]', lb);
    var zoomed = false;
    function lbOpen() { return lb && lb.classList.contains('is-open'); }
    function setZoom(z, ox, oy) {
      zoomed = z;
      if (!lbItem) return;
      lbItem.classList.toggle('is-zoomed', z);
      lbItem.style.transformOrigin = (ox == null ? 50 : ox) + '% ' + (oy == null ? 50 : oy) + '%';
      lbItem.style.transform = z ? 'scale(2.2)' : 'scale(1)';
      if (zoomBtn) zoomBtn.textContent = z ? (B.strings.zoomOut || 'Zoom out') : (B.strings.zoomIn || 'Zoom in');
    }
    function renderLightbox() {
      if (!lbItem || !slides[gi]) return;
      var sl = slides[gi], type = sl.getAttribute('data-media-type'), alt = sl.getAttribute('data-alt') || '';
      lbItem.innerHTML = '';
      setZoom(false);
      if (zoomBtn) zoomBtn.hidden = type !== 'image';
      if (type === 'image') {
        var img = new Image(); img.src = sl.getAttribute('data-zoom-src'); img.alt = alt; lbItem.appendChild(img);
      } else if (type === 'video') {
        var v = document.createElement('video');
        v.src = sl.getAttribute('data-video-src'); v.poster = sl.getAttribute('data-poster') || '';
        v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('aria-label', alt);
        lbItem.appendChild(v);
        if (!reduce) v.play().catch(function () {});
      } else if (type === 'external_video') {
        var host = sl.getAttribute('data-embed-host'), id = sl.getAttribute('data-embed-id');
        var f = document.createElement('iframe');
        f.src = host === 'youtube' ? 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0&playsinline=1' : 'https://player.vimeo.com/video/' + id;
        f.title = alt; f.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture'); f.setAttribute('allowfullscreen', '');
        lbItem.appendChild(f);
      } else {
        var clone = sl.cloneNode(true); clone.classList.add('is-active'); lbItem.appendChild(clone);
      }
      if (lbCounter) lbCounter.textContent = (gi + 1) + ' / ' + slides.length;
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open-lightbox]');
      if (!o || !lb) return;
      e.preventDefault();
      show(parseInt(o.getAttribute('data-open-lightbox'), 10) - 1);
      $$('video', gallery).forEach(function (v) { v.pause(); });
      renderLightbox();
      B.open(lbName, o);
    });
    if (lb) {
      var lp = $('[data-lightbox-prev]', lb), ln = $('[data-lightbox-next]', lb);
      if (lp) lp.addEventListener('click', function (e) { e.stopPropagation(); show(gi - 1); });
      if (ln) ln.addEventListener('click', function (e) { e.stopPropagation(); show(gi + 1); });
      if (zoomBtn) zoomBtn.addEventListener('click', function () { setZoom(!zoomed); });
      lbItem.addEventListener('click', function (e) {
        if (slides[gi] && slides[gi].getAttribute('data-media-type') !== 'image') return;
        var r = lbItem.getBoundingClientRect();
        setZoom(!zoomed, ((e.clientX - r.left) / r.width * 100).toFixed(1), ((e.clientY - r.top) / r.height * 100).toFixed(1));
      });
      lbItem.addEventListener('mousemove', function (e) {
        if (!zoomed) return;
        var r = lbItem.parentElement.getBoundingClientRect();
        lbItem.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      });
      document.addEventListener('keydown', function (e) {
        if (!lbOpen()) return;
        if (e.key === 'ArrowRight') show(gi + 1);
        if (e.key === 'ArrowLeft') show(gi - 1);
      });
      document.addEventListener('brillo:close', function (e) {
        if (e.detail && e.detail.name === lbName && lbItem) {
          lbItem.innerHTML = ''; setZoom(false);
          var btn = slides[gi] && slides[gi].querySelector('[data-open-lightbox], button, video');
          if (btn) btn.focus({ preventScroll: true });
        }
      });
    }

    /* ---------- Variants ---------- */
    var picker = $('[data-variant-picker]', root);
    var json = picker && $('[data-variants-json]', picker);
    var variants = [];
    try { variants = json ? JSON.parse(json.textContent) : []; } catch (e) { variants = []; }
    var form = $('form[data-type="add-to-cart-form"]', root);
    var idInput = form && $('[data-variant-id]', form);
    var addBtn = form && $('[data-add-button]', form);
    var addLabel = addBtn && $('[data-add-label]', addBtn);
    var priceInLabel = addBtn && addBtn.getAttribute('data-price-in-label') === 'true';
    var priceEl = $('[data-product-price]', root);
    var dynamic = form && $('[data-dynamic-checkout]', form);
    var qtyInput = form && $('[data-pqty-input]', form);

    function selectedOptions() {
      return $$('fieldset[data-option-index]', picker).map(function (fs) {
        var c = $('input[data-option-input]:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      })[0] || null;
    }
    function exactVariant(opts) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0] || null;
    }
    function markAvailability(opts) {
      $$('fieldset[data-option-index]', picker).forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        $$('input[data-option-input]', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
          var exists = variants.some(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
          var label = inp.closest('label');
          if (label) label.classList.toggle('is-unavailable', !ok);
          inp.setAttribute('data-exists', exists ? 'true' : 'false');
        });
        var chosen = $('input[data-option-input]:checked', fs), out = $('[data-option-value]', fs);
        if (out && chosen) out.textContent = chosen.value;
      });
    }
    function setButton(v) {
      if (!addBtn) return;
      var text, disabled;
      if (!v) { text = B.strings.unavailable || 'Unavailable'; disabled = true; }
      else if (!v.available) { text = B.strings.soldOut || 'Sold out'; disabled = true; }
      else { text = (B.strings.addToBag || 'Add to Bag') + (priceInLabel ? ' — ' + v.price : ''); disabled = false; }
      addBtn.disabled = disabled;
      if (addLabel) addLabel.textContent = text;
      if (dynamic) {
        dynamic.style.opacity = disabled ? '.45' : '';
        dynamic.style.pointerEvents = disabled ? 'none' : '';
        dynamic.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
      if (idInput) { idInput.disabled = !v || !v.available; if (v) idInput.value = v.id; }
    }
    function setPrice(v) {
      if (!priceEl || !v) return;
      var html = '<span>' + v.price + '</span>';
      if (v.compare) html += '<span class="visually-hidden">' + (B.strings.regularPrice || 'Regular price') + '</span><s>' + v.compare + '</s>';
      priceEl.innerHTML = html;
    }
    function setQtyRules(v) {
      if (!qtyInput || !v) return;
      qtyInput.min = v.min || 1; qtyInput.step = v.step || 1;
      if (v.max) qtyInput.max = v.max; else qtyInput.removeAttribute('max');
      if (parseInt(qtyInput.value, 10) < (v.min || 1)) qtyInput.value = v.min || 1;
    }
    function onChange() {
      var opts = selectedOptions();
      var v = exactVariant(opts);
      markAvailability(opts);
      setButton(v);
      if (v) {
        setPrice(v); setQtyRules(v);
        $$('[data-variant-sku]', root).forEach(function (el) { el.textContent = v.sku || ''; });
        if (v.media) showMediaId(v.media);
        if (baseUrl && window.history && history.replaceState) {
          var url = new URL(baseUrl, window.location.origin); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.pathname + url.search);
        }
        // Keep Shopify's payment terms (installments) and other product forms in sync.
        $$('form[action*="/cart/add"] input[name="id"]', root).forEach(function (i) { if (i !== idInput) i.value = v.id; });
        root.dispatchEvent(new CustomEvent('brillo:variant:change', { bubbles: true, detail: { variant: v } }));
      }
    }
    if (picker && variants.length) {
      picker.addEventListener('change', function (e) { if (e.target.matches('[data-option-input]')) onChange(); });
      markAvailability(selectedOptions());
    }

    /* ---------- Quantity ---------- */
    if (form) form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pqty]'); if (!b || !qtyInput) return;
      e.preventDefault();
      var step = parseInt(qtyInput.step, 10) || 1, min = parseInt(qtyInput.min, 10) || 1, max = parseInt(qtyInput.max, 10) || Infinity;
      var n = (parseInt(qtyInput.value, 10) || min) + parseInt(b.getAttribute('data-pqty'), 10) * step;
      qtyInput.value = Math.min(max, Math.max(min, n));
    });
  }

  function init(scope) { $$('[data-product-section]', scope || document).forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
